export default __webpack_public_path__ + "static/media/work-history.75e18d53.svg";